import { GET_TOPTOURS_ERR, GET_TOPTOURS_REQ, GET_TOPTOURS_RES } from '../constants';
import { handleAsync } from './reducerUtils';

const initState = {
  toptours: [],
  toptours_loaded: false,
  errors: [],
};

const reducer = (state = initState, action) => {
  const next = handleAsync(state, action, { req: GET_TOPTOURS_REQ, res: GET_TOPTOURS_RES, err: GET_TOPTOURS_ERR, dataKey: 'toptours' });
  if (next) return next;

  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
